import React, { Component } from 'react';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import Bubbles from './Bubbles';

import 'react-vertical-timeline-component/style.min.css';
import './vertical-timeline.css';
import './vertical-timeline-element.css';
import './vertical-timeline-container.scss';

const AUIcon = () => {
  return <div className="flag-icon flag-icon-au" />;
};

const SLIcon = () => {
  return <div className="flag-icon flag-icon-lk" />;
};

export default class VerticalTimelineContainer extends Component {
  render() {
    return (
      <section className="vertical-timeline-container" id="work-timeline">
        <div className="container">
          <VerticalTimeline>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="February 2018 - present"
              iconStyle={{ color: '#fff' }}
              icon={<AUIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Digio, Senior Frontend Engineer (Web)
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Melbourne, Australia
              </h4>
              <p>
                Consulting, Front end development (React), Mobile Hybrid
                Application development (React Native), Agile practises,
                Technology evaluation, POCs,
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="August 2015 - February 2018"
              iconStyle={{ color: '#fff' }}
              icon={<AUIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Odecee, Senior Frontend Engineer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Melbourne, Australia
              </h4>
              <p>
                Consulting, Front end development (AngularJs & React), Agile
                practises, Test automation, Unit testing
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="April 2013 - August 2015"
              iconStyle={{ color: '#fff' }}
              icon={<AUIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Yarris, Software Developer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Melbourne, Australia
              </h4>
              <p>
                Fullstack developement (AngularJs, Node), Test automation, Unit
                testing, Agile practises
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="May 2012 - March 2013"
              iconStyle={{ color: '#fff' }}
              icon={<AUIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Toll, Application support
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Melbourne, Australia
              </h4>
              <p>Application support, monitoring, optimising, </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="Oct 2011 - April 2012"
              iconStyle={{ color: '#fff' }}
              icon={<AUIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Touch Networks, Java Developer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Melbourne, Australia
              </h4>
              <p>Java aplication development & testing</p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="Feb 2007 - July 2011"
              iconStyle={{ color: '#fff' }}
              icon={<SLIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Mazarin, Software Engineer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Colombo, Sri Lanka
              </h4>
              <p>
                Software Development, Offshore consulting, Technical business
                analyst, Agile practises
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="Oct 2006 - Feb 2007"
              iconStyle={{ color: '#fff' }}
              icon={<SLIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                GoQuo, Associate Software Engineer
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Colombo, Sri Lanka
              </h4>
              <p>Software development</p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="Oct 2003 - Oct 2005"
              iconStyle={{ color: '#fff' }}
              icon={<SLIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                Web Developer, Atlantis One Technologies
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Colombo, Sri Lanka
              </h4>
              <p>Web design and development</p>
            </VerticalTimelineElement>
          </VerticalTimeline>
          <Bubbles />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VerticalTimeline/VerticalTimelineContainer.js